import React from "react";
import { AlertTriangle } from "lucide-react";
import { debugLog } from "../../utils/debugLog";
import { APP_NAME, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    debugLog.error("ErrorBoundary", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "linear-gradient(135deg, #fee2e2, #fecaca)", fontFamily: FONT_FAMILY
        }}>
          <div style={{
            background: "white", borderRadius: 16, padding: 40, maxWidth: 480, width: "90vw",
            textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.1)"
          }}>
            <AlertTriangle size={ICON_SIZES.xxl} style={{ color: "#ef4444", marginBottom: 16 }} />
            <h2 style={{ margin: "0 0 8px", color: "#1f2937" }}>Something went wrong</h2>
            <p style={{ color: "#6b7280", fontSize: "0.9rem", marginBottom: 8 }}>
              {APP_NAME} encountered an unexpected error.
            </p>
            <p style={{ color: "#9ca3af", fontSize: "0.8rem", marginBottom: 24, fontFamily: "monospace" }}>
              {this.state.error?.message || "Unknown error"}
            </p>
            <button onClick={() => window.location.reload()} style={{
              padding: "10px 24px", borderRadius: 8, border: "none",
              background: "#ef4444", color: "#fff", fontSize: "0.9rem",
              fontWeight: 600, cursor: "pointer", fontFamily: FONT_FAMILY
            }}>Reload Application</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
